import { Card, Checkbox, FormControlLabel, Stack, TextField, Tooltip, Typography } from "@mui/material";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import { useContext } from "react";
import { NewFormContext } from "../../context/NewFormContext";
import { ChecklistType } from "../../types/checklist/types";

export default function Aprovacao() {
  const { modelo, setModelo } = useContext(NewFormContext);

  function handleCangeNumeroAprovadores(event: React.ChangeEvent<HTMLInputElement>) {
    setModelo((prev: ChecklistType) =>
      prev
        ? {
            ...prev,
            aprovacaoConfig: {
              ...prev.aprovacaoConfig,
              numeroAprovadores: parseInt(event.target.value) < 1 ? 1 : parseInt(event.target.value),
            },
          }
        : null,
    );
  }

  function handleChangeAprovacaoOrdenada(event: React.ChangeEvent<HTMLInputElement>) {
    setModelo((prev: ChecklistType) =>
      prev
        ? {
            ...prev,
            aprovacaoConfig: {
              ...prev.aprovacaoConfig,
              aprovacaoOrdenada: event.target.checked,
            },
          }
        : null,
    );
  }

  return (
    <Card sx={{ width: "100%", padding: 2 }}>
      <Stack direction="column" justifyContent="center" alignItems="center" spacing={1.5} width="100%">
        <Typography color="textDisabled" variant="h5" textAlign="center" fontWeight={600} width="100%">
          Configuração de aprovação por modelo
        </Typography>
        <Stack width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Tooltip title="O número mínimo por modelo é um aprovador (não pode ser menor do que 1)">
              <AnnouncementIcon />
            </Tooltip>
            <Typography variant="subtitle1">Numero de aprovadores para este modelo</Typography>
            <TextField
              inputProps={{ min: 1, style: { textAlign: "center", width: "80px" } }}
              size="small"
              type="number"
              variant="outlined"
              value={modelo?.aprovacaoConfig?.numeroAprovadores}
              onChange={handleCangeNumeroAprovadores}
            />
          </Stack>
          <Stack direction="row" spacing={1} alignItems="center">
            <Tooltip title="Se marcado a ordem de aprovação deverá ser conforme ordem definida na edição de aprovação">
              <AnnouncementIcon />
            </Tooltip>
            <FormControlLabel
              control={<Checkbox checked={modelo?.aprovacaoConfig?.aprovacaoOrdenada} onChange={handleChangeAprovacaoOrdenada} />}
              label="Aprovação ordenada"
              labelPlacement="start"
            />
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
}
